import React, { useEffect, useState, useRef } from "react";
import {
  AppBar,
  Button,
  ButtonGroup,
  Checkbox,
  FormControlLabel,
  FormGroup,
  MenuItem,
  Select,
  TextField,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import toast from "react-hot-toast";
import ReactQuill from "react-quill";
import { Link, useHistory, useLocation } from "react-router-dom";
import "../index.css";
import http from "../services/httpService";
import handleSubmitValidation from "../utils/handleSubmitValidation";
import handleValidation from "../utils/handleValidations";
import { beigeManagementPath } from "../utils/varialbles";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControl from "@material-ui/core/FormControl";
import { ElevenMpTwoTone } from "@mui/icons-material";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    paddingTop: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  submitButton: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(5),
  },
  gridDevider: {
    marginTop: theme.spacing(6),
    textAlign: "left",
    color: theme.palette.text.primary,
  },
  lableColor: {
    color: "#393939",
    paddingTop: "10px",
  },
  select: {
    height: 36,
    width: 235,
    marginLeft: 25,
  },
  mobileCode: {
    height: 36,
  },
  radio: {
    "&$checked": {
      color: "#57bf74",
    },
  },

  checked: {},
}));
let disableImageurl = true;
let hideTextArea = true;
let base64URl = "";
function AddNotificationRequest() {
  const fileInputRef = useRef(null);
  let history = useHistory();
  const [questionner, setQuestionner] = useState([]);
  const [conditionArray, setConditionArray] = useState([]);
  const [categoryDropDowm, setcategoryDropDowm] = useState([]);
  const [bodyImage, setBodyImage] = useState("");
  const location = useLocation();
  let form = {
    name: "",
    type: "1",
    subject: "",
    body: "",
    category: "P",
    // "image": null,
    // "frequency": "",
    // "timeslot": "",
  };

  let conditionForm = {
    category: "",
    condition: "",
    choice_type: null,
    choice_array: [],
    condition_array: [],
    choice: "",
    is_mandatory: false,
  };
  const formats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
    "color",
  ];

  const [formObject, setFromObject] = useState(form);
  const validations = {
    name: {
      conditions: {
        required: true,
        maxLength: 100,
      },
      message: "This Field is required!",
      valid: true,
      changed: false,
    },

    subject: {
      conditions: {
        required: true,
        maxWordLength: 10,
        delimiter: " ",
      },
      message: "Maximum 20 character Allowed.!",
      valid: true,
      changed: false,
    },
    body: {
      conditions: {
        required: true,
        maxWordLength: 500,
        delimiter: " ",
      },
      message: "Maximum 1000 character Allowed.!",
      valid: true,
      changed: false,
    },
    // "frequency": {
    //     conditions: {
    //         "required": true
    //     }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
    // },
    // "timeslot": {
    //     conditions: {
    //         "required": true
    //     }, "message": "Maximum 1000 character Allowed.!", "valid": true, "changed": false
    // },
  };
  const [validationState, setValidationState] = useState(validations);
  let userQuestionnaire = [
    // { "lable": "Source Channel*", "filedType": "dropDown" },
    {
      lable: "Name",
      imp: true,
      filedType: "text",
      disabled: false,

      value: "name",
      display: true,
    },
    {
      lable: "Subject",
      imp: true,
      filedType: "text",
      disabled: false,

      value: "subject",
      display: true,
    },
    {
      value: "frequency",
      lable: "Type",
      minWidth: 150,
      disabled: false,

      imp: true,
      filedType: "radio",
      display: true,
    },
    {
      lable: "Body",
      imp: true,
      filedType: "textarea",
      disabled: false,

      value: "body",
      display: true,
    },
    // { "lable": 'Time Slot', "value": 'timeslot', "minWidth": 150, "imp": true, "filedType": "dropDown", "display": true },
    // {
    //     "lable": "image", "imp": false,
    //     "disabled": false,
    //     "filedType": "text", "value": "image", "display": true
    // },

    // { "lable": "Condition", "filedType": "dropDown", "value": "category", "display": false },
  ];
  const classes = useStyles();
  const handleTextChangeChange = (value) => {
    setFromObject({
      ...formObject,
      body: value,
    });
  };

  const checkValidation = () => {
    let name = "body";
    let value = formObject.body;
    let valid = true;
    let validStateTemp = { ...validationState };
    if (name && validStateTemp.hasOwnProperty(name)) {
      let validation = handleValidation(name, value, validStateTemp);

      setValidationState(validation.validStateTemp);
      valid = validation.valid;
    }
  };
  const handleCancel = () => {
    http
      .get("/send_notification")
      .then((response) => {
        if (
          response.data &&
          response.data.Data &&
          Array.isArray(response.data.Data) &&
          response.data.Data.length > 0
        ) {
          setQuestionner(response.data.Data);
          let cdrop = response.data.Data.filter((obj) => {
            return obj.question === "Category";
          });
          if (cdrop && cdrop.length > 0 && cdrop[0]["options"]) {
            setcategoryDropDowm(cdrop[0]["options"]);
          }
          setConditionArray([conditionForm]);
        } else {
          // toast.error("Questioner Data Not Available for this investor..!");
          history.goBack();
        }
      })
      .catch((error) => {
        // toast.error("Questioner Data Not Available for this investor..!");
        history.goBack();
      });
  };
  useEffect(() => {
    handleCancel();
    disableImageurl = true;
    hideTextArea = true;
  }, []);
  const handleChange = (event, boolean) => {
    let name = event.target.name;
    let value = event.target.value;
    let valid = true;
    let validStateTemp = { ...validationState };
    if (name === "type") {
      if (value === "3") {
        hideTextArea = false;
        // setFromObject({
        //   ...formObject,
        //   body: ""
        // })
        setFromObject((prevState) => ({
          ...prevState,
          body: "",
        }));
      } else {
        hideTextArea = true;
        // fileInputRef.current.value = "";
        setBodyImage("");
      }
    }
    if (name && validStateTemp.hasOwnProperty(name)) {
      let validation = handleValidation(name, value, validStateTemp);
      setValidationState(validation.validStateTemp);
      valid = validation.valid;
    }
    if (valid || value === "" || value == 0) {
      if (boolean && value === "false") {
        value = false;
      } else if (boolean && value == "true") {
        value = true;
      }
      setFromObject({
        ...formObject,
        [event.target.name]: event.target.value,
      });
      if (event.target.name === "type") {
        if (event.target.value === "1" && event.target.name === "type") {
          disableImageurl = false;
        } else {
          disableImageurl = true;
        }
      }
    }
  };
  const handleFileChange = async (event) => {
    setBodyImage(event.target.files[0]);
    const file = event.target.files[0];
    base64URl = await convertBase64(file);
  };
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleSubmit = (event) => {
    let finalDatas = { ...formObject };
    var strippedHtml = formObject.body.replace(/<[^>]+>/g, "");
    const secondRegEx = /((&nbsp;))*/gim;
    finalDatas.body = strippedHtml.replace(secondRegEx, "");
    let validStateTemp = { ...validationState };
    let validCount = 0;
    let finalObjet = { ...formObject };
    finalObjet["type"] = [];
    let validData = handleSubmitValidation(finalObjet, validStateTemp);
    validCount = validData.validCount;
    const formData = new FormData();
    let updatedCount = 0;
    // let bodys = 'sertvhb';
    if (bodyImage !== "") {
      updatedCount = 1;
      formData.append("image", base64URl);
      finalDatas.image = base64URl;
      finalDatas.body = "Click here to view interactive version";
    } else {
      updatedCount = 0;
      formData.append("body", finalDatas["body"]);
    }
    if (validCount === updatedCount) {
      userQuestionnaire.map((obj) => {
        let filter = [];
        if (obj["filedType"] == "dropDown" && !obj["boolean"]) {
          filter = questionner.filter((question) => {
            return question.question === obj.lable;
          });
          if (filter.length > 0) {
            let value = filter[0].options.filter((option) => {
              return option.values === finalObjet[obj.value];
            });
            if (value.length > 0) {
              finalObjet[obj.value] = value[0]["name"];
            }
          }
        }

        if (obj["boolean"] && finalObjet[obj.value] != 1) {
          finalObjet[obj.value] = 0;
        }
      });
      let conditionArrayTemp = [...conditionArray];
      let finalCondition = [];
      conditionArrayTemp.map((object, index) => {
        if (
          object["category"] === "" ||
          object["condition"] === "" ||
          object["choice"] === ""
        ) {
        }
        //  else {
        //     let cat = getCategoryValue(object["category"])
        //     let condition = object.condition_array.filter(obj => {
        //         return obj.id === object["condition"]
        //     })
        //     let con = (condition && condition.length > 0 && condition[0]['name']) ? condition[0]['name'] : null;
        //     let cho = null;
        //     if (object['choice_type'] === "Drop Down") {
        //         let choice = object.choice_array.filter(obj => {
        //             return obj.id === object["choice"]
        //         })
        //         cho = (choice && choice.length > 0 && choice[0]['name']) ? choice[0]['name'] : null;
        //     } else if (object["choice"] === 0 || object["choice"]) {
        //         cho = object["choice"]
        //     }
        //     if (cat && con && cho) {
        //         finalCondition.push({
        //             "category": categoryMaper[cat] ? categoryMaper[cat] : cat,
        //             "condition": conditionMaper[con] ? conditionMaper[con] : con,
        //             "choice": cho,
        //             "mandatory": object["is_mandatory"] ? "True" : "False"
        //         })
        //     }
        // }
      });
      // finalObjet["conditions"] = finalCondition;

      http
        .post("/send_new_notification", finalDatas)
        .then((response) => {
          if (response.data.statusCode === 0) {
            // alert(2);
            toast.success("Notification Sent Successfully..!");
            makeActive();
          } else {
            toast.error("Notification Request Failed..!");
          }
          // setFromObject(form)
        })
        .catch((error) => {
          // toast.error("Questioner Data Not Available for this investor..!");
        });
    } else {
      setValidationState(validData.validStateTemp);
      toast.error("Please check Errors in Field level!");
    }
  };

  const makeActive = (event) => {
    history.push({
      pathname: beigeManagementPath,
      state: { tab: "Notification Manager" },
    });
  };

  // const addNewCondtion = (e) => {
  //     e.preventDefault();
  //     let conditionTemp = [...conditionArray];
  //     conditionTemp.push(conditionForm);
  //     setConditionArray(conditionTemp);

  // }
  const deleteConditon = (e, inx) => {
    let conditionTemp = [...conditionArray];
    conditionTemp.splice(inx, 1);
    setConditionArray(conditionTemp);
  };
  const handleCategoryChange = (e, index, fname) => {
    let conditionTemp = [...conditionArray];
    let value = e.target.value;
    if (fname) {
      conditionTemp[index][fname] = e.target.checked;
    } else {
      conditionTemp[index][e.target.name] = value;
    }
    if (value !== "" && e.target.name === "category") {
      conditionTemp[index]["condition"] = "";
      conditionTemp[index]["choice_type"] = null;
      conditionTemp[index]["choice_array"] = [];
      conditionTemp[index]["condition_array"] = [];
      conditionTemp[index]["choice"] = "";
      http.get("/dropdownquery?category_value=" + value).then((response) => {
        if (
          response.data &&
          response.data.Data &&
          Array.isArray(response.data.Data) &&
          response.data.Data.length > 0
        ) {
          if (response.data.Data[0]["Condition"]) {
            let conditionTempArray =
              response.data.Data[0]["Condition"].split(",");
            conditionTempArray = conditionTempArray.map((str, inx) => {
              return { id: inx + 1, name: str };
            });
            let choice = response.data.Data[0].Choice;
            if (choice && Array.isArray(choice) && choice.length > 0) {
              conditionTemp[index]["choice_type"] = "Drop Down";
              conditionTemp[index]["choice_array"] = choice;
            } else {
              conditionTemp[index]["choice_type"] = choice ? choice : null;
            }
            conditionTemp[index]["condition_array"] = conditionTempArray;
          }
          setConditionArray(conditionTemp);
        }
      });
    } else {
      setConditionArray(conditionTemp);
    }
  };
  // console.log(formObject, 'formObject');
  return (
    <Grid container component="main">
      <AppBar
        position="static"
        style={{ marginBottom: 5, paddingTop: 3, paddingBottom: 3 }}
        className={classes.paper}
      >
        <Grid container component="main">
          <Grid item xs={6} sm={6} md={6}>
            <ButtonGroup>
              <Button
                variant="outlined"
                color="default"
                style={{ marginLeft: 10 }}
                onClick={() => makeActive()}
                name="invOverView"
                startIcon={<ArrowBackIosIcon />}
              >
                Back
              </Button>
            </ButtonGroup>
          </Grid>
        </Grid>
      </AppBar>
      <Grid item xs={false} sm={5} md={5}></Grid>
      <Grid item xs={false} sm={5} md={5}>
        <Typography color="textPrimary" variant="h5">
          Create Notification
        </Typography>
      </Grid>
      <Grid container style={{ marginTop: 50 }}>
        {userQuestionnaire.map((question) => {
          return question.display ? (
            <Grid container className={classes.paper} key={question.value}>
              <Grid item xs={false} sm={2} md={2}>
                <InputLabel
                  className={classes.lableColor}
                  id={question.lable + "label"}
                  style={{
                    display:
                      disableImageurl === true && question.lable === "image"
                        ? "none"
                        : "block",
                  }}
                >
                  {question.lable}
                  {question.imp && (
                    <span
                      style={{
                        color: "red",
                        fontSize: "1.2rem",
                        marginLeft: "0.2rem",
                      }}
                    >
                      *
                    </span>
                  )}
                </InputLabel>
              </Grid>
              <Grid item lg={5} md={5} sm={5}>
                {question.filedType === "radio" ? (
                  <>
                    {/* <div style={{ display: "flex" }}>
                      <input
                        type="radio"
                        id="push"
                        value="1"
                        name="type"
                        onChange={handleChange}
                        style={{ width: "20px", cursor: "pointer" }}
                      />
                      <label
                        for="push"
                        style={{
                          marginTop: "4px",
                          marginRight: "10px",
                          cursor: "pointer",
                        }}
                      >
                        Push
                      </label>
                      <input
                        type="radio"
                        id="in_app"
                        value="2"
                        name="type"
                        onChange={handleChange}
                        style={{ width: "20px", cursor: "pointer" }}
                      />
                      <label
                        for="in_app"
                        style={{
                          marginTop: "4px",
                          marginRight: "10px",
                          cursor: "pointer",
                        }}
                      >
                        In-App
                      </label>
                      <input
                        type="radio"
                        id="daily_update"
                        value="3"
                        name="type"
                        onChange={handleChange}
                        style={{ width: "20px", cursor: "pointer" }}
                      />
                      <label
                        for="in_app"
                        style={{
                          marginTop: "4px",
                          marginRight: "10px",
                          cursor: "pointer",
                        }}
                      >
                        Daily Update
                      </label>
                    </div> */}
                    <FormControl>
                      <RadioGroup
                        aria-labelledby="demo-radio-buttons-group-label"
                        // defaultValue=""
                        name="type"
                        row
                        value={formObject.type}
                        onChange={handleChange}
                      >
                        <FormControlLabel
                          value="1"
                          control={
                            <Radio
                              classes={{
                                root: classes.radio,
                                checked: classes.checked,
                              }}
                            />
                          }
                          label="Push"
                        />
                        <FormControlLabel
                          value="2"
                          control={
                            <Radio
                              classes={{
                                root: classes.radio,
                                checked: classes.checked,
                              }}
                            />
                          }
                          label="In-App"
                        />
                        <FormControlLabel
                          value="3"
                          control={
                            <Radio
                              classes={{
                                root: classes.radio,
                                checked: classes.checked,
                              }}
                            />
                          }
                          label="Daily Update"
                        />
                      </RadioGroup>
                    </FormControl>
                  </>
                ) : question.filedType === "number" ? (
                  <TextField
                    label="Enter"
                    variant="outlined"
                    value={formObject[question.value]}
                    name={question.value}
                    onChange={handleChange}
                    className={classes.select}
                    type="number"
                  />
                ) : question.filedType === "textarea" ? (
                  <>
                    {" "}
                    {hideTextArea !== true ? (
                      <>
                        <input
                          ref={fileInputRef}
                          onChange={handleFileChange}
                          type="file"
                          style={{ display: "none" }}
                          multiple={false}
                          accept=".png,.PNG,.JPEG,.jpeg,.jpg,.JPG"
                        />
                        <Button
                          startIcon={<AddCircleOutlineIcon />}
                          variant="outlined"
                          className={classes.reviewButton}
                          color="primary"
                          onClick={() => fileInputRef.current.click()}
                        >
                          Choose File
                        </Button>
                        <span style={{ marginLeft: 10 }}>
                          {bodyImage && bodyImage.name
                            ? bodyImage.name
                            : "No file chosen"}
                        </span>
                      </>
                    ) : (
                      <>
                        <div style={{ height: 200 }}>
                          <ReactQuill
                            value={formObject[question.value]}
                            onChange={handleTextChangeChange}
                            onBlur={checkValidation}
                            name={question.value}
                            style={{ width: 400, height: 150 }}
                            formats={formats}
                            theme={"snow"}
                          />
                        </div>
                        {validationState.hasOwnProperty(question.value) &&
                          validationState[question.value]["changed"] &&
                          !validationState[question.value]["valid"] ? (
                          <div
                            style={{
                              color: "#f44336",
                              fontSize: "0.75rem",
                              margin: "3px 14px",
                            }}
                          >
                            {validationState[question.value]["message"]}
                          </div>
                        ) : null}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <TextField
                      label="Enter"
                      variant="outlined"
                      value={formObject[question.value]}
                      className={
                        disableImageurl === true && question.value === "image"
                          ? "hideimageurl"
                          : "showimageurl"
                      }
                      // disabled={disableImageurl === true && question.value === "imageURL"}

                      name={question.value}
                      onChange={handleChange}
                      style={
                        validationState.hasOwnProperty(question.value) &&
                          validationState[question.value]["changed"] &&
                          !validationState[question.value]["valid"]
                          ? { paddingBottom: 20 }
                          : {}
                      }
                      error={
                        validationState.hasOwnProperty(question.value) &&
                        validationState[question.value]["changed"] &&
                        !validationState[question.value]["valid"]
                      }
                      helperText={
                        validationState.hasOwnProperty(question.value) &&
                          validationState[question.value]["changed"] &&
                          !validationState[question.value]["valid"]
                          ? validationState[question.value]["message"]
                          : ""
                      }
                    />
                  </>
                )}
              </Grid>
            </Grid>
          ) : (
            ""
          );
        })}
      </Grid>
      {conditionArray.map((obj, inx) => {
        return (
          <Grid container key={"carray" + inx} className={classes.paper}>
            <Grid item xs={12} sm={2} md={2}>
              <InputLabel className={classes.lableColor} id={"conditionlabel"}>
                {conditionArray.length > 1
                  ? "Category " + (inx + 1)
                  : "Category"}
                <span
                  style={{
                    color: "red",
                    fontSize: "1.2rem",
                    marginLeft: "0.2rem",
                  }}
                >
                  *
                </span>
              </InputLabel>
            </Grid>
            {/* <Grid item xs={12} md={4} sm={6} lg={2}>
                                <Select displayEmpty labelId={"carray" + inx + "label"} id="statusSelect" variant="outlined" className={classes.select, "select"} onChange={e => handleCategoryChange(e, inx)} value={(obj["category"]) ? obj["category"] : ""} name={"category"}>
                                    <MenuItem value="">Select</MenuItem>
                                    {categoryDropDowm.map((option, index) => {
                                        return <MenuItem value={option.values} key={"cdropdown" + index + inx}>{option.name}</MenuItem>
                                    })}
                                    )
                                </Select>
                            </Grid> */}

            {/* <FormControl component="fieldset">  
                                <RadioGroup aria-label="gender" value={(obj["category"]) ? obj["category"] : ""} name="category" onChange={handleChange}>
                                    <FormControlLabel value="invester" name="category" control={<Radio color="primary" />} label="Invester" />
                                    <FormControlLabel value="prospect" name="category" control={<Radio color="primary" />} label="Prospect" />
                                    <FormControlLabel value="both" name="category" control={<Radio color="primary" />} label="Both" />                                    
                                </RadioGroup>
                            </FormControl> */}
            <>
              {/* <input
                type="radio"
                id="prospect"
                value="P"
                name="category"
                onChange={handleChange}
                style={{ width: "20px", cursor: "pointer" }}
              />
              <label
                for="prospect"
                style={{
                  marginTop: "7px",
                  marginRight: "10px",
                  cursor: "pointer",
                }}
              >
                Prospect
              </label>
              <input
                type="radio"
                id="investor"
                value="C"
                name="category"
                onChange={handleChange}
                style={{ width: "20px", cursor: "pointer" }}
              />
              <label
                for="investor"
                style={{
                  marginTop: "7px",
                  marginRight: "10px",
                  cursor: "pointer",
                }}
              >
                Investor
              </label>

              <input
                type="radio"
                id="both"
                value="B"
                name="category"
                onChange={handleChange}
                style={{ width: "20px", cursor: "pointer" }}
              />
              <label
                for="both"
                style={{
                  marginTop: "7px",
                  marginRight: "10px",
                  cursor: "pointer",
                }}
              >
                Both
              </label> */}
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  // defaultValue="female"
                  name="category"
                  row
                  value={formObject.category}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    value="P"
                    control={
                      <Radio
                        classes={{
                          root: classes.radio,
                          checked: classes.checked,
                        }}
                      />
                    }
                    label="Prospect"
                  />
                  <FormControlLabel
                    value="C"
                    control={
                      <Radio
                        classes={{
                          root: classes.radio,
                          checked: classes.checked,
                        }}
                      />
                    }
                    label="Investor"
                  />
                  <FormControlLabel
                    value="B"
                    control={
                      <Radio
                        classes={{
                          root: classes.radio,
                          checked: classes.checked,
                        }}
                      />
                    }
                    label="Both"
                  />
                </RadioGroup>
              </FormControl>
            </>

            {obj.condition_array.length > 0 ? (
              <Grid item xs={12} md={4} sm={6} lg={2}>
                <Select
                  displayEmpty
                  labelId={"condidropdown" + inx + "label"}
                  id="statusSelect"
                  variant="outlined"
                  className={(classes.select, "select")}
                  onChange={(e) => handleCategoryChange(e, inx)}
                  value={obj["condition"] ? obj["condition"] : ""}
                  name={"condition"}
                >
                  <MenuItem value="">Select</MenuItem>
                  {obj.condition_array.map((option, index) => {
                    return (
                      <MenuItem
                        value={option.id}
                        key={"condidropdown" + index + inx}
                      >
                        {option.name}
                      </MenuItem>
                    );
                  })}
                  )
                </Select>
              </Grid>
            ) : (
              ""
            )}
            {obj.choice_type && obj.choice_type === "Calender Date" ? (
              <Grid item xs={12} md={4} sm={6} lg={2}>
                <TextField
                  id="datePickerId"
                  label="Select Date"
                  type="date"
                  // defaultValue="07:30"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  format="YYYY-MM-DD"
                  value={obj["choice"]}
                  onChange={(e) => handleCategoryChange(e, inx)}
                  name={"choice"}
                  className={(classes.select, "select")}
                />
              </Grid>
            ) : obj.choice_type && obj.choice_type === "TextBox" ? (
              <Grid item xs={12} md={4} sm={6} lg={2}>
                <TextField
                  label="Enter Choice"
                  variant="outlined"
                  disabled={obj.disable}
                  value={obj["choice"]}
                  name={"choice"}
                  onChange={(e) => handleCategoryChange(e, inx)}
                  className={(classes.select, "select")}
                />
              </Grid>
            ) : obj.choice_type && obj.choice_type === "Number Box" ? (
              <Grid item xs={12} md={4} sm={6} lg={2}>
                <TextField
                  label="Enter Choice"
                  variant="outlined"
                  value={obj["choice"]}
                  name={"choice"}
                  onChange={(e) => handleCategoryChange(e, inx)}
                  className={(classes.select, "select")}
                  type="number"
                />
              </Grid>
            ) : obj.choice_type && obj.choice_type === "Drop Down" ? (
              <Grid item xs={12} md={4} sm={6} lg={2}>
                <Select
                  displayEmpty
                  labelId={"chice" + inx + "label"}
                  id="statusSelect"
                  variant="outlined"
                  className={(classes.select, "select")}
                  onChange={(e) => handleCategoryChange(e, inx)}
                  value={obj["choice"] ? obj["choice"] : ""}
                  name={"choice"}
                >
                  <MenuItem value="">Select</MenuItem>
                  {obj.choice_array.map((option, index) => {
                    return (
                      <MenuItem value={option.id} key={"choice" + index + inx}>
                        {option.name}
                      </MenuItem>
                    );
                  })}
                  )
                </Select>
              </Grid>
            ) : (
              ""
            )}
            {obj.choice === "" || obj.condition === "" ? (
              ""
            ) : (
              <Grid item xs={12} md={3} sm={3} lg={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      value={obj["is_mandatory"]}
                      classes={{
                        root: classes.radio,
                        checked: classes.checked,
                      }}
                      checked={obj.is_mandatory}
                      onChange={(e) =>
                        handleCategoryChange(e, inx, "is_mandatory")
                      }
                      name="is_mandatory"
                    />
                  }
                  label="Is this mandatory?"
                  labelPlacement="start"
                />
              </Grid>
            )}
            {inx > 0 ? (
              <Grid item sm={1} md={1}>
                <DeleteOutlinedIcon
                  onClick={(e) => deleteConditon(e, inx)}
                  style={{
                    cursor: "pointer",
                    marginTop: "6px",
                    backgroundColor: "#d76565",
                    color: "white",
                    borderRadius: "50%",
                  }}
                ></DeleteOutlinedIcon>
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        );
      })}
      {/* <Grid container className={classes.submitButton}>
                <Grid item xs={false} sm={2} md={2} >
                    <Link onClick={addNewCondtion}>Add Condition</Link>
                </Grid>
            </Grid> */}
      <Grid container className={classes.submitButton}>
        <Grid item xs={false} sm={2} md={2}></Grid>
        <Grid item xs={3} sm={1} md={1}>
          {/* <Button variant="outlined" color="default" onClick={handleCancel}>Cancel</Button> */}
        </Grid>

        <Grid item xs={3} sm={1} md={1}>
          <Button
            variant="contained"
            color="primary"
            // disabled={true}
            onClick={handleSubmit}
          >
            Create
          </Button>
        </Grid>
      </Grid>
    </Grid>
  );
}

// function AddNotificationRequest(){
//     return(
//         <h2>Create Notification</h2>

//     );
// }

export default AddNotificationRequest;
